import { queryParamsToSession } from '../../lib/funnels/functions/v1/default/queryParamsToSession'
import { updateSession } from '../../lib/funnels/functions/v1/default/updateSession'
import { initAbandonModal } from '../../lib/funnels/functions/v1/default/abandonmentModal'

import './index.css'
import '../styles/modal.css'

document.addEventListener('DOMContentLoaded', () => {
  // -------------------

  const SESSION_ID = 'tdMainFunnel'

  queryParamsToSession(SESSION_ID)

  initAbandonModal()

  // @ts-ignore
  window.clickDebtOption = function clickDebtOption(debtAmount) {
    try {
      sessionStorage.setItem('savings-left-via-click', '1')
    } catch {
      // nothing
    }
    updateDebtOwed(debtAmount)

    if (
      debtAmount === '7000' ||
      debtAmount === '7500' ||
      debtAmount === '9999'
    ) {
      window.location.href =
        '/onboarding/savings-v2/?funnel=veracity-onboarding-alt'
      return
    }

    window.location.href = '/savings-estimates/submit/'
  }

  /**
   * @param {string} debtAmount
   */
  function updateDebtOwed(debtAmount) {
    updateSession(SESSION_ID, 'debtOwed', debtAmount)
  }
})
